export default __webpack_public_path__ + "static/media/download.78661618.svg";